import { CmsIcon } from '@domgen/dgx-fe-cms';

export interface CmsProtectionBenefitIconListItem {
  benefit: string;
  icon: CmsIcon;
}
